import GithubLogo from './GithubLogo';

const getUrl = (link: string) => {
  try {
    const url = new URL(link);
    let path = url.pathname;
    if (path.startsWith('/')) path = path.slice(1);
    return path;
  } catch {
    // pass
  }

  return null;
};

export function GithubLink(props: { link: string }) {
  const path = getUrl(props.link);
  if (!path) return null;
  return (
    <span
      className="mt-2 flex items-center gap-1.5 text-xs text-tertiary hover:underline"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(props.link);
      }}
    >
      <GithubLogo className="flex-shrink-0" />
      <span>{path}</span>
    </span>
  );
}
